// extracted by mini-css-extract-plugin
export var accent = "_86-4";
export var add = "_86-j";
export var addIcon = "_86-k";
export var deleteIcon = "_86-i";
export var disabled = "_86-9";
export var ellipsis = "_86-f";
export var error = "_86-3";
export var form = "_86-5";
export var hideFocus = "_86-2";
export var icon = "_86-7";
export var input = "_86-e";
export var listItem = "_86-h";
export var mediumHeight = "_86-b";
export var noBorder = "_86-8";
export var noRadius = "_86-1";
export var shortHeight = "_86-a";
export var tallHeight = "_86-c";
export var textInput = "_86-0";
export var vertical = "_86-g";
export var veryTallHeight = "_86-d";
export var widget = "_86-6";